import $ from 'jquery';
import 'bootstrap';
import DataService from './DataService';
import MapService from './MapService';
import Layout from './Layout';
let layout = new Layout();

let initSlider = (orientation) => {
	console.log(orientation);
	$('.carousel').carousel();
	var viewportmeta = document.querySelector('meta[name="viewport"]');
	if (viewportmeta) {
		if (orientation === 'portrait') {
			viewportmeta.setAttribute(
				'content',
				'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
			);
		} else {
			viewportmeta.setAttribute(
				'content',
				'width=device-width, initial-scale=1.0, maximum-scale=2, viewport-fit=cover'
			);
		}
	}
};

let refreshContent = async () => {
	const dataService = new DataService();
	const id = window.location.hash.replace('#', '');
	$('.btn-back-to-list')
		.show()
		.attr('href', '/spuren.html#' + id);
	const data = await dataService.get('locations', id);

	const mapService = new MapService('#map', [data], true);
	mapService.initMap();
	mapService.center([data.longitude, data.latitude]);
	$('.orientation-notification').remove();
	data.attachments = data.attachments || [];
	$('[data-bind]').each((index, element) => {
		const key = $(element).data('bind');
		let content = data[key];
		if (key === 'content') {
			content = layout.addDntParamToAllExternalResourcesInContent(content);
		}
		$(element).html(content);
	});

	layout.initCards();

	document.querySelectorAll('a[href^="http"]').forEach((anchor) => {
		anchor.setAttribute('target', '_blank');
	});

	if (data.attachments.length) {
		data.attachments.sort((a, b) => (a.fileName > b.fileName ? 1 : b.fileName > a.fileName ? -1 : 0));
		$('.carousel-inner').empty();
		$('ol.carousel-indicators').empty();
		data.attachments.forEach((item, i) => {
			switch (item.extension) {
				case 'jpeg':
				case 'jpg':
				case 'png':
					let carouselItem = $("<div class='carousel-item' />");

					carouselItem.append(`<img src="${item.url}"/>`);
					$('.carousel-inner').append(carouselItem);
					let carouselIndicator = $(`<li data-target='#carouselExampleIndicators' data-slide-to='${i}' />`);

					$('ol.carousel-indicators').append(carouselIndicator);
					break;
				// case 'mp3':
				// 	carouselItem.append(`<div class="mt-5 mb-5"><audio controls class="mt-5 mb-5">
				// 		<source src="${item.url}" type="audio/mpeg">
				// 		Ihr Gerät unterstützt keine MP3-Wiedergabe
				// 	</audio></div>`);
				// 	break;
				default:
					break;
			}
		});

		$('.carousel-inner').children().first().addClass('active');
		$('ol.carousel-indicators').children().first().addClass('active');

		let orientation = 'portrait';

		if (window.matchMedia('(orientation: landscape)').matches) {
			orientation = 'landscape';
		}
		initSlider(orientation);

		window.addEventListener('deviceorientation', function (event) {
			console.log('deviceorientation event', event);
			try {
				console.log('Orientation of the device is now ' + event.alpha);

				let orientation = event.alpha > 0 ? 'landscape' : 'portrait';
				initSlider(orientation);
			} catch (error) {}
		});

		window.addEventListener('orientationchange', function (event) {
			console.log('orientationchange event', event);
			try {
				let orientation = event.target.screen.orientation.angle > 0 ? 'landscape' : 'portrait';
				initSlider(orientation);
			} catch (error) {
				//Might be iOS
				console.log(error);

				let orientation = event.target.orientation !== 0 ? 'landscape' : 'portrait';
				initSlider(orientation);
			}
		});

		$('.carousel').on('slide.bs.carousel', function () {
			console.log('slide.bs.carousel');
		});
	} else {
		$('.carousel').hide();
	}
};

window.addEventListener('hashchange', refreshContent, false);
window.addEventListener('load', refreshContent, false);
